import { render, staticRenderFns } from "./SubSamplePhoto.vue?vue&type=template&id=279d4b0c&"
import script from "./SubSamplePhoto.vue?vue&type=script&lang=js&"
export * from "./SubSamplePhoto.vue?vue&type=script&lang=js&"
import style0 from "./SubSamplePhoto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports